import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { ILineaInfraestructura, LineaInfraestructuraTipo, RequestPatchLineaInfraestructura, RequestPostLineaInfraestructura } from '@app/core/interfaces/linea-infraestructura';

@Injectable({
  providedIn: 'root'
})
export class LineasInfraestructuraService {

  urlLineasInfraestructura = environment.api_base_url + '/lineaInfraestructuras';
  urlLineasInfraestructuraTipo = environment.api_base_url + '/lineaInfraestructuraTipos';

  public error422Api$: Subject<RespApi> = new Subject<RespApi>();
  public lineaInfraestructura$: BehaviorSubject<ILineaInfraestructura> = new BehaviorSubject<ILineaInfraestructura>(null);
  public totalLineasInfraestructura$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public lineaInfraestructuraTipo$: BehaviorSubject<LineaInfraestructuraTipo> = new BehaviorSubject<LineaInfraestructuraTipo>(null);
  public totalLineasInfraestructuraTipo$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set lineaInfraestructura(lineaInfraestructura: ILineaInfraestructura) {
    this.lineaInfraestructura$.next(lineaInfraestructura);
  }

  set lineaInfraestructuraTipo(lineaInfraestructuraTipo: LineaInfraestructuraTipo) {
    this.lineaInfraestructuraTipo$.next(lineaInfraestructuraTipo);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ILineaInfraestructura[]> {
    if (paginatorType === TipoPaginadorEnum.offline) {
      return this.http.get(`${this.urlLineasInfraestructura}?${ this.auxiliar.extraerFiltros(filtros) }`, {})
      .pipe(
        tap( (data: RespApi )=> {
          this.totalLineasInfraestructura$.next( data.total );
        }),
        map((data: RespApi) => this.mapearLineasInfraestructura(data['data']) ));
    } else {
      return this.http.get(`${this.urlLineasInfraestructura}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
        tap( (data: RespApi )=> {this.totalLineasInfraestructura$.next( data.total );}),
        map((data: RespApi) => this.mapearLineasInfraestructura(data['data']) ));
      }
  }

  get(id): Observable<ILineaInfraestructura>{
    return this.http.get(`${this.urlLineasInfraestructura}/${id}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }

  mapearLineasInfraestructura( lineas: ILineaInfraestructura[] ) {
    if (lineas.length) {
      lineas.forEach((element, index )=> {
        lineas[index] = this.mapearLineaInfraestructura( element );
      });
    }
    return lineas;
  }

  mapearLineaInfraestructura( linea: ILineaInfraestructura ):ILineaInfraestructura{
    // linea.importe  = +linea.importe;
    linea.unidades = +linea.unidades;
    return linea;
  }

  create(request: RequestPostLineaInfraestructura): Observable<any>{
    return this.http.post<RespApi>( `${this.urlLineasInfraestructura}`, request ) .pipe(
      map( (resp: RespApi) => resp.data),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostLineaInfraestructura');
      })
    );
  }

  update(id: string, request: RequestPatchLineaInfraestructura) {
    return this.http.patch( `${this.urlLineasInfraestructura}/${id}`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPatchLineaInfraestructura');
      })
    );
  }

  delete(id: string) {
    return this.http.delete( `${this.urlLineasInfraestructura}/${id}` ).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestDeleteLineaInfraestructura');
      })
    );
  }

  private handleError(err: RespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    if (err == 'Unknown Error') {
      let mensaje = environment.errorServidorUnknown;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    if ( err.codigoError === 422) {
      err.request = idRequest;
      this.error422Api$.next(err);
    } 

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if ( err.data ) {
        err.data.forEach(element => {
          if ( element.id === 999 ) {
            avisos = ' ' + element.mensaje + ' ';
          }
        });
      }
      mensaje = err?.mensaje +  avisos;
    }
    return throwError({'error' : true, 'data': err.data, mensaje });
  }
  
  
}

